import { render, staticRenderFns } from "./SentenceAddElementsList.vue?vue&type=template&id=409d1e82"
import script from "./SentenceAddElementsList.vue?vue&type=script&lang=js"
export * from "./SentenceAddElementsList.vue?vue&type=script&lang=js"
import style0 from "./SentenceAddElementsList.vue?vue&type=style&index=0&id=409d1e82&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports